import script from "./BaseImage.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseImage.vue?vue&type=script&setup=true&lang=js"

import "./BaseImage.vue?vue&type=style&index=0&id=3fe2126a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fe2126a"]])

export default __exports__